import React from 'react'
import {
  Box,
  Grid,
  Stack,
  Text,
  UnorderedList,
  ListItem,
  Link,
} from '@chakra-ui/react'
import { Trans, useTranslation } from 'react-i18next'

type ManualPaymentInstructionsProps = {
  finalPrice: string
  dueDate: string
}

export const ManualPaymentInstructions = ({
  finalPrice,
  dueDate,
}: ManualPaymentInstructionsProps): React.ReactElement => {
  const { t } = useTranslation(['freeTrial'])

  return (
    <Stack
      spacing={4}
      sx={{
        p: 6,
        border: '1px solid',
        borderColor: 'gray.200',
        borderRadius: 'lg',
        bg: 'gray.50',
      }}
    >
      <Text sx={{ fontWeight: 'bold', fontSize: 'lg', color: 'gray.900' }}>
        {t('form.manualPayment.title', { finalPrice })}
      </Text>

      <Box
        sx={{
          bg: 'white',
          borderRadius: 'md',
          border: '1px solid',
          borderColor: 'gray.200',
          p: 4,
        }}
      >
        <Grid templateColumns="1fr 2fr 1.5fr" gap={4} mb={2}>
          <Text fontWeight="bold" fontSize="sm">
            {t('form.manualPayment.table.bank')}
          </Text>
          <Text fontWeight="bold" fontSize="sm">
            {t('form.manualPayment.table.accountName')}
          </Text>
          <Text fontWeight="bold" fontSize="sm">
            {t('form.manualPayment.table.accountNo')}
          </Text>
        </Grid>

        <Grid templateColumns="1fr 2fr 1.5fr" gap={4}>
          <Text fontSize="sm">{t('form.manualPayment.table.kbank')}</Text>
          <Text fontSize="sm">{t('form.manualPayment.table.compName')}</Text>
          <Text fontSize="sm">{t('form.manualPayment.table.compNo')}</Text>
        </Grid>
      </Box>

      <Stack spacing={4}>
        <Box>
          <Text fontWeight="bold" fontSize="md" mb={2}>
            {t('form.manualPayment.proof.title')}
          </Text>
          <UnorderedList styleType="disc" pl={4} spacing={2}>
            <ListItem sx={{ fontSize: 'sm', color: 'gray.600', lineHeight: 'tall' }}>
              <Trans t={t} i18nKey="form.manualPayment.proof.email">
                กรุณาส่งหลักฐานการโอนเงินมาที่
                <Link
                  href="mailto:sales@datawow.io"
                  sx={{ color: 'brand.400', fontWeight: 'bold', textDecor: 'underline' }}
                >
                  sales@datawow.io
                </Link>
              </Trans>
            </ListItem>
            <ListItem sx={{ fontSize: 'sm', color: 'gray.600', fontWeight: 'medium', lineHeight: 'tall' }}>
              {t('form.manualPayment.proof.suspend', { date: dueDate })}
            </ListItem>
          </UnorderedList>
        </Box>

        <Box>
          <Text fontWeight="bold" fontSize="md" mb={2}>
            {t('form.manualPayment.term.title')}
          </Text>
          <UnorderedList styleType="disc" pl={4} spacing={2}>
            <ListItem sx={{ fontSize: 'sm', color: 'gray.600', lineHeight: 'tall' }}>
              {t('form.manualPayment.term.desc')}
            </ListItem>
          </UnorderedList>
        </Box>
      </Stack>
    </Stack>
  )
}
